/**
 * API-Schlüssel erzeugen.
 *
 * Das Format muss Zeichen für Zeichen dem entsprechen, was
 * `scripts/testkunde-anlegen.mjs` erzeugt — sonst gibt es zwei Arten von
 * Schlüsseln, und die Widerruf-Anleitung in AGENTS.md (`where key_prefix =
 * 'ntk_xxxx'`) trifft die eine Hälfte nicht:
 *
 *   key        'ntk_' + 16 Zufallsbytes als Hex   (36 Zeichen)
 *   key_hash   SHA-256 des Schlüssels als Hex     (gespeichert wird nur das)
 *   key_prefix die ersten 8 Zeichen               ('ntk_' + 4 Hex)
 *
 * WARUM DER BROWSER DEN SCHLÜSSEL ERZEUGT UND NICHT DER SERVER: Nur so
 * existiert der Klartext an genau einer Stelle — im Speicher dieses Tabs, für
 * die Dauer einer Anzeige. Ginge er über eine Edge Function, stünde er in
 * deren Antwort und damit potenziell in einem Log. `crypto.getRandomValues`
 * ist dafür die richtige Quelle; `Math.random` wäre es nicht.
 *
 * Der Klartext wird NIE gespeichert, auch nicht im localStorage. Wer ihn
 * verliert, legt einen neuen an. Genau das sagt die Oberfläche auch.
 */

import { MCP_URL } from './config';

const PRAEFIX = 'ntk_';
const ZUFALLSBYTES = 16;

const hex = (bytes: Uint8Array): string =>
  Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');

export async function sha256Hex(input: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
  return hex(new Uint8Array(buf));
}

export interface NeuerSchluessel {
  /** Der Klartext. Existiert nur hier und in der Anzeige. */
  key: string;
  key_hash: string;
  key_prefix: string;
}

export async function erzeugeSchluessel(): Promise<NeuerSchluessel> {
  const bytes = new Uint8Array(ZUFALLSBYTES);
  crypto.getRandomValues(bytes);
  const key = PRAEFIX + hex(bytes);
  return { key, key_hash: await sha256Hex(key), key_prefix: key.slice(0, 8) };
}

/** Für die Liste: nie den Klartext, nur den erkennbaren Anfang. */
export const schluesselAnzeige = (prefix: string): string => `${prefix}…`;

/**
 * Der Befehl fuer Claude Code, mit oder ohne Schluessel.
 *
 * An einer Stelle, weil er auf der Konto- und der Schluesselseite steht und
 * dort einmal mit Platzhalter, einmal mit frischem Klartext erscheint. Zwei
 * handgeschriebene Fassungen driften — und ein Kunde kopiert dann die falsche.
 */
export const claudeCodeBefehl = (key?: string): string =>
  `claude mcp add --transport http 99takes ${MCP_URL}${key ? ` --header "x-api-key: ${key}"` : ''}`;
